import * as React from 'react';

import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

export const EmbedSnippetText = (
    <Body size='normal'>
        Copy and paste this Nutshell snippet into the <code>{`<head>`}</code> of every page of your
        site.{' '}
        <Link
            href='https://support.nutshell.com/en/articles/8429026-nutshell-analytics-tracking-website-visitors'
            variant='primary'
            newTab={true}
            size='normal'
        >
            Learn more
        </Link>
    </Body>
);
